// SceneForm.form.js
import * as Yup from "yup";

export function initialValuesThree(scene) {
  return {
    ModThreeTitle: scene?.ModThreeTitle || "",
    ModThreeContent: scene?.ModThreeContent || "",
    ModThreeImagesObjetives: scene?.ModThreeImagesObjetives || [],
    ModThreeSubcontent: scene?.ModThreeSubcontent || "",
  };
}

// Validation Schema
export function validationSchemaThree() {
  return Yup.object({
    ModThreeTitle: Yup.string().required("El título es obligatorio"),
    ModThreeContent: Yup.string().required("El contenido es obligatorio"),
    ModThreeImagesObjetives: Yup.array().of(Yup.string()),
    ModThreeSubcontent: Yup.string(),
  });
}
